import React from "react";
import { FileSpreadsheet, FileText, Mail, CalendarClock } from "lucide-react";

/**
 * Export actions as a clean horizontal row of adjacent, monochrome
 * buttons (PDF / Excel / Share / Schedule) — no per-action color,
 * consistent spacing/sizing, matching the rest of the design language.
 */
const ExportMenu = ({ onExcel, onPdf, onEmail, onSchedule, theme, isRTL, text, language, disabled }) => {
  const isDark = theme === "dark";

  const actions = [
    ["exportPdf", FileText, onPdf],
    ["exportExcel", FileSpreadsheet, onExcel],
    ["exportEmail", Mail, onEmail],
    ["exportSchedule", CalendarClock, onSchedule],
  ].filter(([, , handler]) => !!handler);

  const border = isDark ? "rgba(255,255,255,0.14)" : "rgba(0,0,0,0.12)";

  return (
    <div
      style={{
        display: "inline-flex", borderRadius: 11, overflow: "hidden",
        border: `1px solid ${border}`, flexDirection: isRTL ? "row-reverse" : "row",
        opacity: disabled ? 0.5 : 1, pointerEvents: disabled ? "none" : "auto",
      }}
    >
      {actions.map(([key, Icon, handler], i) => (
        <button
          key={key}
          type="button"
          onClick={handler}
          title={text[language][key]}
          style={{
            display: "flex", alignItems: "center", gap: 6, padding: "9px 14px",
            border: "none", borderInlineStart: i === 0 ? "none" : `1px solid ${border}`,
            background: isDark ? "rgba(255,255,255,0.04)" : "#fff",
            color: isDark ? "#e2e8f0" : "#334155",
            fontSize: 12.5, fontWeight: 600, cursor: "pointer",
            flexDirection: isRTL ? "row-reverse" : "row",
            whiteSpace: "nowrap",
          }}
          onMouseEnter={(e) => { e.currentTarget.style.background = isDark ? "rgba(255,255,255,0.09)" : "rgba(0,0,0,0.04)"; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = isDark ? "rgba(255,255,255,0.04)" : "#fff"; }}
        >
          <Icon size={14} /> {text[language][key]}
        </button>
      ))}
    </div>
  );
};

export default ExportMenu;
